import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';
import { CustomValidators } from '../shared/validators/CustomValidators';
import { UserInfo } from 'src/app/store/actions/user.action';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
declare var $: any;
declare var bootstrap: any;

declare var window:any;
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent {
  formSubmitting=false;
  plans:any;
  gymOwnerForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    re_email: ['', Validators.compose([Validators.required])],
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    first_name: ['', Validators.compose([Validators.required])],
    re_password: ['', Validators.compose([Validators.required,Validators.minLength(8)])],
    last_name: ['', Validators.compose([Validators.required])],
    form_type: ['coach', Validators.compose([Validators.required])],
    // number_of_coaches: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
    // number_of_athletes: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
    number_of_coaches: [''],
    number_of_athletes: [''],
    plan:[''],
    trial:[0]
  },
  { validators: [CustomValidators.MatchValidator('password', 're_password'),CustomValidators.MatchValidator('email', 're_email')] }
  );

  constructor(private fb: FormBuilder,private store: Store<AppState>, public webApi: WebapiService, private toastrService: ToastrService, public router: Router) {
    this.getPlans('coach')
    this.gymOwnerForm.get('trial').valueChanges.subscribe(val => {
      if (val==0) {
        this.gymOwnerForm.controls['plan'].setValidators([Validators.required]);
      } else {
        this.gymOwnerForm.controls['plan'].clearValidators();
      }
      this.gymOwnerForm.controls['plan'].updateValueAndValidity();
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }


  changeFormType(formtype){
    this.gymOwnerForm.patchValue({
      plan: "",
    });
    this.getPlans(formtype.replace(/_/g, ""))
  }

  getValue(field){
    if(this.gymOwnerForm.controls[field].value!=""){
      return false
    }else{
      return true;
    }
  }

  selectFree(){
    this.gymOwnerForm.patchValue({
      plan: "",
    });
  }
  

  onSigup(form: FormGroup) {
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      if(form.value.plan==""){
        form.value.trial=1
      }
      let trial=form.value.trial
      this.webApi.signup(form.value).subscribe((data: any) => {
        if (data.success) {
          let email = form.value.email;
          let password = form.value.password;
          form.reset();
					this.toastrService.success(data.message);
          if(trial!=1 && data.redirecturl && data.redirecturl!=""){
            window.location.href=data.redirecturl;
          }else{
            this.login(email,password);
          }
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  getPlans(type){
    this.webApi.getPlans(type).subscribe((data: any) => {
      if (data.success) {
        if(type=="gymowner"){
          let dataplans=data.plans;
          this.plans = [];
          let count=0;
          for(let i=0; i<dataplans.length;i++){
            if(dataplans[i].title.indexOf('Novice-Median')!=-1){
              if(!this.plans['0']){
                this.plans['0']=[];
              }
              this.plans['0'][count]=[];
              this.plans['0'][count]['title']=dataplans[i].title
              this.plans['0'][count]['plan']=dataplans[i]
              this.plans['0'][count]['index']=i
            }else if(dataplans[i].title.indexOf('Novice-Premier')!=-1){
              if(!this.plans['1']){
                this.plans['1']=[];
              }
              this.plans['1'][count]=[];
              this.plans['1'][count]['title']=dataplans[i].title
              this.plans['1'][count]['plan']=dataplans[i]
              this.plans['1'][count]['index']=i
            }else if(dataplans[i].title.indexOf('Novice-Advanced')!=-1){
              if(!this.plans['2']){
                this.plans['2']=[];
              }
              this.plans['2'][count]=[];
              this.plans['2'][count]['title']=dataplans[i].title
              this.plans['2'][count]['plan']=dataplans[i]
              this.plans['2'][count]['index']=i
            }
            count++;
          }
  
          if(this.plans['0']){
            this.plans['0'] = this.plans['0'].filter((val:any)=>{return val});
          }
          
          if(this.plans['1']){
            this.plans['1'] = this.plans['1'].filter((val:any)=>{return val});
          }
          if(this.plans['2']){
            this.plans['2'] = this.plans['2'].filter((val:any)=>{return val});
          }
          this.plans = this.plans.filter((val:any)=>{return val});
        }else if(type=="coach"){
          let dataplans=data.plans;
        this.plans = [];
        let count=0;
        for(let i=0; i<dataplans.length;i++){
          if(dataplans[i].title.indexOf('Novice-Median')!=-1){
            if(!this.plans['0']){
              this.plans['0']=[];
            }
            this.plans['0'][count]=[];
            this.plans['0'][count]['title']=dataplans[i].title
            this.plans['0'][count]['plan']=dataplans[i]
            this.plans['0'][count]['index']=i
          }else if(dataplans[i].title.indexOf('Novice-Advanced')!=-1){
            if(!this.plans['1']){
              this.plans['1']=[];
            }
            this.plans['1'][count]=[];
            this.plans['1'][count]['title']=dataplans[i].title
            this.plans['1'][count]['plan']=dataplans[i]
            this.plans['1'][count]['index']=i
          }else if(dataplans[i].title.indexOf('Novice-Premier')!=-1){
            if(!this.plans['2']){
              this.plans['2']=[];
            }
            this.plans['2'][count]=[];
            this.plans['2'][count]['title']=dataplans[i].title
            this.plans['2'][count]['plan']=dataplans[i]
            this.plans['2'][count]['index']=i
          }
          count++;
        }

        if(this.plans['0']){
          this.plans['0'] = this.plans['0'].filter((val:any)=>{return val});
        }
        
        if(this.plans['1']){
          this.plans['1'] = this.plans['1'].filter((val:any)=>{return val});
        }

        if(this.plans['2']){
          this.plans['2'] = this.plans['2'].filter((val:any)=>{return val});
        }

        this.plans = this.plans.filter((val:any)=>{return val});
        }

        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
      } else {
        this.toastrService.error(data.message);
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.gymOwnerForm.controls;
  }

  login(email,password){ {
        this.webApi.login(email,password).subscribe((data: any) => {
          if(data.success){
            this.store.dispatch(new UserInfo())
            this.webApi.setLoader(true)
            this.webApi.setSession(data);
            if(data.new_message && data.new_message?.id){
              console.log(data.new_message)
              this.webApi.newMessage = data.new_message
              setTimeout(()=>{
                if(document.getElementById('new-message-modal')){
                  var myModal2 = new bootstrap.Modal(document.getElementById('new-message-modal'), {
                    keyboard: true
                  })
                  myModal2.show()
                }
              },15300)
              //$('#new-message-modal').modal('show');
            }
            if(data.new_videos && data.new_videos.length){
              this.webApi.newVideos = data.new_videos
              setTimeout(()=>{
                if(document.getElementById('new-videos-modal')){
                  var myModal = new bootstrap.Modal(document.getElementById('new-videos-modal'), {
                    keyboard: true
                  })
                  myModal.show()
                }
              },300)
              ///$('#new-videos-modal').modal('show');
            }
            if(data.showdisclaimer){
              setTimeout(()=>{
                if(document.getElementById('disclaimer-modal')){
                  var myModal1 = new bootstrap.Modal(document.getElementById('disclaimer-modal'), {
                    keyboard: true
                  })
                  myModal1.show()
                }
              },30300)
            }
            $('dropdown-menu.login-menu').trigger('click');
            this.router.navigateByUrl('/video');
            this.webApi.setLoader(false)
          }else{
            if(data.olduser && data.olduser==1){
              this.router.navigateByUrl('/forgot-password')
            }
            this.toastrService.error(data.message);
          }
        },
        error => {
          this.toastrService.error("unable to handle response");
          this.formSubmitting=false;
        });
      }
    }
}


